/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2024] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function SearchInProgressCustomerOrders(parameters) {
  const response = await $.soap({
    body: {
      SearchInProgressCustomerOrders: {
        $xmlns: 'http://dla.mil/ems/bpm/order/customer_order',
        OrderID: parameters?.customerOrderID,
        SerialNumber: parameters?.serialNumber
      }
    },
    blueprintArrays: ['SearchInProgressCustomerOrdersResponse.Response.tuple.old.rowset.row'],
    blueprint: {
      orders: [
        '$..old.rowset.row',
        {
          orderID: '$.ID',
          assignedCrs: '$.AssignedCRS',
          orderType: '$.OrderType',
          orderStatus: '$.OrderStatus',
          popStartDate: '$.POPDate',
          command: '$.Command',
          commandId: '$.CommandID',
          region: '$.Region',
          submittedOn: '$.SubmittedOn',
          replacementPIINSPIIN: '$.ReplacementPIINSPIIN',
          serialNumber: '$.SerialNumber'
        }
      ]
    }
  });
  cleanUpResponse(response);
  return response;
}
